import { CommonModule } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { FiltersModule } from '../filters/filters.module';
import { JwtInterceptor } from '../helpers/jwt.interceptor';
import { OrganizationsModule } from '../organizations/organizations.module';
import { ProjectsModule } from '../projects/projects.module';
import { OrganizationService } from '../services/identity/organization.service';
import { UserService } from '../services/identity/user.service';
import { ImageService } from '../services/shared/image.service';
import { SharedModule } from '../shared/shared.module';
import { UserModule } from '../user/user.module';
import { DmsRoutingModule } from './dms-routing.module';
import { WudoDocumentViewerComponent } from './pages/wudo-document-viewer/wudo-document-viewer.component';
import { DmsComponent } from './dms.component';
import { AppDmsRedirectComponent } from './Redirections/app-dms-redirect/app-dms-redirect.component';

@NgModule({
    declarations: [WudoDocumentViewerComponent, DmsComponent, AppDmsRedirectComponent],
    imports: [
        CommonModule,
        HttpClientModule,
        FiltersModule,
        ProjectsModule,
        UserModule,
        SharedModule,
        OrganizationsModule,
        FormsModule,
        DmsRoutingModule,
    ],
    exports: [WudoDocumentViewerComponent],
    providers: [
        OrganizationService,
        UserService,
        ImageService,
        { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    ],
})
export class DmsModule {}
